<template>
  <NavListItem
    v-if="!listItem.isGroup && listItem.show"
    :class="itemClass"
    :activeClass="itemActiveClass"
    :name="listItem.text"
    :icon="listItem.icon"
    :linkName="listItem.linkName"
    @navClick="$emit('item-clicked', false)"
  />
  <v-list-group
    v-else-if="listItem.isGroup && listItem.show && getOptionIsVisible()"
    no-action
    :prepend-icon="listItem.icon"
    active-class="drawer-dropdown-group-active"
    class="mb-2 drawer-dropdown-group"
    :value="isActive()"
    :sub-group="isSubGroup"
    :no-action="isSubGroup"
  >
    <template v-slot:activator>
      <v-list-item-title>{{ listItem.text }}</v-list-item-title>
    </template>
    <template v-for="(subItem, subIndex) in listItem.items">
      <NavListItemGroup
        :listItem="subItem"
        :index="subIndex"
        itemClass="drawer-dropdown-item"
        itemActiveClass="drawer-list-item-active"
        isSubGroup
        @item-clicked="$emit('item-clicked', false)"
      />
    </template>
  </v-list-group>
</template>

<script>
import NavListItem from './NavListItem.vue'
export default {
  name: 'NavListItemGroup',
  components: {
    NavListItem,
  },
  props: {
    listItem: {
      type: Object,
      default: () => {},
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    itemClass: {
      type: String,
      default: 'drawer-list-item',
    },
    itemActiveClass: {
      type: String,
      default: 'drawer-list-item-active',
    },
    isSubGroup: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getOptionIsVisible() {
      // test the case if a item is a group but all of it sub items are invisible i.e. show = false
      // true = visible
      // false = invisible
      const item = this.listItem
      if (this.listItem.isGroup) {
        if (item.items) {
          const foundVisibleSubItem = item.items.find(obj => obj.show)
          return this.listItem.show && (foundVisibleSubItem ? true : false)
        }
        return false
      }

      return this.listItem.show
    },
    isActive() {
      const item = this.listItem
      if (item.isGroup && item.items) {
        const possibleLinkNames = this._getAllLinkNames(item.items)
        return possibleLinkNames.includes(this.$route.name)
      }

      return false
    },
    _getAllLinkNames(items) {
      let names = []
      for (let i = 0; i < items.length; i++) {
        if (items[i].isGroup) {
          names = names.concat(this._getAllLinkNames(items[i].items))
        } else {
          names.push(items[i].linkName)
        }
      }
      return names
    },
  },
}
</script>
